export function LoginScreen({ onSignIn }) {
  return (
    <div className="min-h-screen bg-cream-100 flex flex-col items-center justify-center px-4">
      <div className="max-w-sm w-full text-center">
        {/* Logo */}
        <div className="mb-8">
          <div className="flex items-end justify-center gap-3 mb-2">
            <h1 className="font-display text-6xl font-bold text-ink-900 leading-none">
              Wortschatz
            </h1>
            <span className="text-4xl mb-1">🇩🇪</span>
          </div>
          <p className="text-ink-700/60 text-lg mt-3">
            German vocabulary, one deck at a time.
          </p>
        </div>

        {/* Card */}
        <div className="bg-cream-50 border-2 border-ink-900 rounded-2xl p-8 shadow-card-lg">
          <h2 className="font-display text-2xl font-semibold text-ink-900 mb-2">
            Welcome
          </h2>
          <p className="text-ink-700/60 text-sm mb-8">
            Sign in to save your progress across all your devices and compete with friends.
          </p>

          <button
            onClick={onSignIn}
            className="w-full flex items-center justify-center gap-3 py-3.5 px-6
                       bg-cream-50 border-2 border-ink-900 rounded-xl font-semibold
                       text-ink-900 shadow-card hover:shadow-card-hover
                       hover:translate-x-0.5 hover:translate-y-0.5
                       transition-all duration-150 active:scale-[0.98]"
          >
            {/* Google logo SVG */}
            <svg width="20" height="20" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            Continue with Google
          </button>

          <p className="text-xs text-ink-700/40 mt-6">
            Your progress is saved securely and privately.
          </p>
        </div>

        {/* Feature hints */}
        <div className="mt-6 grid grid-cols-3 gap-3 text-center">
          {[
            { emoji: "📱", label: "Any device" },
            { emoji: "🔄", label: "Auto sync" },
            { emoji: "🏆", label: "Leaderboard" },
          ].map(({ emoji, label }) => (
            <div key={label} className="bg-cream-50 border border-ink-900/10 rounded-xl p-3">
              <div className="text-2xl mb-1">{emoji}</div>
              <div className="text-xs text-ink-700/60 font-medium">{label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
